import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const CashfuseChart = ({ data }) => {
  const [merchantCount, setMerchantCount] = useState(Array(12).fill(0));
  const [userCount, setUserCount] = useState(Array(12).fill(0));

  useEffect(() => {
    const updatedMerchantCount = Array(12).fill(0);
    const updatedUserCount = Array(12).fill(0);

    if (data?.merchantMonthlyCounts) {
      data.merchantMonthlyCounts.forEach((item) => {
        updatedMerchantCount[item._id - 1] = item.merchantCount;
      });
      setMerchantCount(updatedMerchantCount);
    }

    if (data?.userMonthlyCounts) {
      data.userMonthlyCounts.forEach((item) => {
        updatedUserCount[item._id - 1] = item.userCount;
      });
      setUserCount(updatedUserCount);
    }
  }, [data]);

  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const chartData = {
    series: [
      {
        name: "Merchant",
        data: merchantCount,
      },
      {
        name: "User",
        data: userCount,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#E73921", "#025D89"],
      stroke: {
        show: true,
        width: 0.4,
        colors: ["transparent"],
        dashArray: 1,
      },
      xaxis: {
        categories: monthNames,
      },
      fill: {
        opacity: 1,
      },
      legend: {
        position: "top",
        horizontalAlign: "center",
        offsetX: 0,
      },
    },
  };

  return (
    <div className="overflow-x-auto">
      <div id="chart" className="min-w-[425px]">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={350}
        />
      </div>
    </div>
  );
};

export default CashfuseChart;
